import s from './enablingNotificationsModal.module.scss';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../../hooks/useNotifications';
import { useSubscribeToNotifications } from '../../api/notificationsApi';
import { useSearchParams } from 'react-router-dom';
import type { BaseModalProps } from '@bnetex/ui-kit/modal';
import { Modal } from '@bnetex/ui-kit/modal';
import { Button } from '@bnetex/ui-kit/button';
import { useState } from 'react';
import { SubscriptionStatusContent } from '../subscriptionStatusContent/subscriptionStatusContent';
import type { ResourceKeys } from 'i18next';

const modalTitleRecord: Record<NotificationPermission, ResourceKeys['notifications']> = {
    default: 'activatingNotifications',
    denied: 'notificationsNotEnabled',
    granted: 'notificationsEnabled',
};

export const EnablingNotificationsModal = ({ onClose }: BaseModalProps) => {
    const { t } = useTranslation('notifications');
    const [ subscribe ] = useSubscribeToNotifications();
    const {
        browser,
        isLoading,
    } = useNotifications();
    const [ _, setParams ] = useSearchParams();
    const [ subscriptionStatus, setSubscriptionStatus ] = useState<NotificationPermission>('default');

    const handleSubmit = () => {
        // Очищаем query параметры, которые могут появляться после оплаты или активации демо-подписки
        setParams('');
        browser?.registerFirebaseToken().then(([ permission, token ]) => {
            switch (permission) {
                case 'granted':
                    return token && subscribe({ token }).then(() => setSubscriptionStatus('granted'));
                case 'denied':
                    return setSubscriptionStatus('denied');
                default:
                    onClose();
            }
        });
    };

    const pendingContent = (
        <>
            <p>
                {t('allowNotifications')}
            </p>
            <p className={s['paragraph']}>
                {t('disableNotifications')}
            </p>
            <Button
                fillContainer={true}
                className={s['button']}
                showLoader={isLoading}
                text={t('activatingNotificationsAction')}
                onClick={handleSubmit}
            />
        </>
    );

    const content = subscriptionStatus === 'default'
        ? pendingContent
        : (
            <SubscriptionStatusContent
                onClose={onClose}
                status={subscriptionStatus}
            />
        );

    return (
        <Modal
            onClose={onClose}
            title={t(modalTitleRecord[subscriptionStatus])}
        >
            {content}
        </Modal>
    );
};
